import {noop} from 'lodash';
import React from 'react';
import styled from 'styled-components';

import {Skeleton, SkeletonColorSchemesEnum} from '../../../components/common/skeleton';
import {FolderBreadcrumb} from '../../../components/folderBreadcrumbs/folderBreadcrumbs';
import {StyledSettingsContent, StyledSettingsMain, StyledSettingsWrapper} from '../../common/settingsWrapper';
import {RuleRecipe} from '../library/recipes';
import {StyledRuleEditorWrapper} from './ruleEditor';
import {StyledRuleEditorForm} from './ruleEditorForm';
import {RuleEditorHeader} from './ruleEditorHeader';

/*
 * Types.
 */

interface RuleEditorSkeletonProps {
  namespace: string;
  recipe?: RuleRecipe;
  isEditing: boolean;
  isActive: boolean;
  breadcrumbs: ReadonlyArray<FolderBreadcrumb>;
}

/*
 * Styles.
 */

const StyledSpacer = styled.div<{$marginBottom: string}>`
  margin-bottom: ${(p) => p.$marginBottom};
`;

const StyledSidebarContainerDiv = styled.div`
  margin-left: 24px;
`;

/*
 * Component.
 */

export const RuleEditorSkeleton = ({
  namespace,
  recipe,
  isEditing,
  isActive,
  breadcrumbs,
}: RuleEditorSkeletonProps) => (
  <StyledSettingsWrapper>
    <RuleEditorHeader
      namespace={namespace}
      recipe={recipe}
      isReadonly={false}
      isEditing={isEditing}
      breadcrumbs={breadcrumbs}
      isActive={isActive}
      onUpdateIsActive={noop}
    />
    <StyledSettingsMain>
      <StyledRuleEditorWrapper>
        <StyledSettingsContent>
          <StyledRuleEditorForm>
            <Skeleton width="120px" height="18px" scheme={SkeletonColorSchemesEnum.GREY30} />
            <StyledSpacer $marginBottom="20px" />
            <Skeleton height="40px" scheme={SkeletonColorSchemesEnum.GREY10} />

            <StyledSpacer $marginBottom="40px" />
            <Skeleton width="65px" height="24px" scheme={SkeletonColorSchemesEnum.GREY30} />
            <StyledSpacer $marginBottom="12px" />
            <Skeleton height="50px" scheme={SkeletonColorSchemesEnum.GREY10} />

            <StyledSpacer $marginBottom="30px" />
            <Skeleton width="65px" height="24px" scheme={SkeletonColorSchemesEnum.GREY30} />
            <StyledSpacer $marginBottom="12px" />
            <Skeleton height="50px" scheme={SkeletonColorSchemesEnum.GREY10} />
            <StyledSpacer $marginBottom="8px" />
            <Skeleton height="50px" scheme={SkeletonColorSchemesEnum.GREY10} />
            <StyledSpacer $marginBottom="8px" />
            <Skeleton height="50px" scheme={SkeletonColorSchemesEnum.GREY10} />

            <StyledSpacer $marginBottom="30px" />
            <Skeleton width="65px" height="24px" scheme={SkeletonColorSchemesEnum.GREY30} />
            <StyledSpacer $marginBottom="12px" />
            <Skeleton height="50px" scheme={SkeletonColorSchemesEnum.GREY10} />
          </StyledRuleEditorForm>
        </StyledSettingsContent>
      </StyledRuleEditorWrapper>
      <StyledSidebarContainerDiv>
        <Skeleton height="290px" width="268px" scheme={SkeletonColorSchemesEnum.GREY10} borderRadius="14px" />
        <StyledSpacer $marginBottom="20px" />
        <Skeleton height="100px" scheme={SkeletonColorSchemesEnum.GREY10} borderRadius="14px" />
      </StyledSidebarContainerDiv>
    </StyledSettingsMain>
  </StyledSettingsWrapper>
);
